<template>
  <div>
      <div v-if="loading" class="text-center">
        <b-spinner type="grow" style="width: 6rem; height: 6rem;" variant="primary" label="Spinning" />
      </div>
      <div v-else>
    <!-- <div v-for="i in Math.ceil(pieces.length / 3)" :key="i" class="artwork__row"> -->
    <div class="artwork__row">
    <!-- <div v-for="piece in pieces.slice((i - 1) * 3, i * 3)" :key="piece.id" class="col-lg-4"> -->
    <div v-for="piece in pieces" :key="piece.id" class="artwork__column">
    <!-- <div v-for="piece in pieces.slice((i - 1) * 3, i * 3)" :key="piece.id" class="artwork__column"> -->
      <CardSmall :piece='piece' class="mb-md"/>
</div>
  </div>
  </div>
  </div>
</template>

<script>
import CardSmall from "@/components/CardSmall.vue";
export default {
  components: {
    CardSmall
  },
  props: [ "pieces" ],
  computed: {
  groupedPieces() {
    return _.chunk(this.pieces, 3)
  },
      loading () {
      return this.$store.getters.loading
    }
}
}
</script>

